import ReviewAndSubmitStep from './ReviewAndSubmitStep.vue'
import { reviewAndSubmitDescriptor } from './descriptor'
import { createReviewAndSubmitController } from './review-and-submit-controller'

const reviewAndSubmitStepImplementation = Object.freeze({
    descriptor: reviewAndSubmitDescriptor,
    component: ReviewAndSubmitStep,
    createController: createReviewAndSubmitController,
})

export {
    ReviewAndSubmitStep,
    createReviewAndSubmitController,
    reviewAndSubmitDescriptor,
    reviewAndSubmitStepImplementation,
}
